// Display helpers (ported from ui SimpleDateTimePickerModal helpers).

export function formatDateUS(s) {
  if (!s) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (!m) return s;
  return `${m[2]}-${m[3]}-${m[1]}`;
}

export function formatTime12h(s) {
  if (!s) return '';
  const m = /^(\d{2}):(\d{2})/.exec(s);
  if (!m) return s;
  const h24 = Number(m[1]);
  const min = m[2];
  const period = h24 < 12 ? 'AM' : 'PM';
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  return `${h12}:${min} ${period}`;
}

// Stable color from a string, for letter-avatar fallbacks.
const TINTS = ['#6366f1', '#ec4899', '#14b8a6', '#f59e0b', '#8b5cf6', '#ef4444', '#2563eb', '#0d9488'];
export function hashTint(str) {
  const s = String(str || '');
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return TINTS[Math.abs(h) % TINTS.length];
}

export function initial(str) {
  return (String(str || '?').trim().charAt(0) || '?').toUpperCase();
}

// Plain-text preview of (possibly) rich-text HTML — for compact spots (cards,
// headers, table cells) where rendering block-level HTML would break layout.
export function stripHtml(html) {
  if (!html) return '';
  if (!/[<&]/.test(html)) return html; // already plain
  const el = document.createElement('div');
  // Space after block ends / line breaks so "<p>A</p><p>B</p>" reads "A B", not "AB".
  el.innerHTML = html.replace(/<\/(p|div|li|h[1-6]|ul|ol|blockquote)>|<br\s*\/?>/gi, '$& ');
  return (el.textContent || '').replace(/\s+/g, ' ').trim();
}
